function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { any, arrayOf, bool, func, node, object, oneOfType, string } from 'prop-types';
import { textFieldClasses } from '@mui/material/TextField';
import { inputBaseClasses } from '@mui/material/InputBase';
import { selectClasses } from '@mui/material/Select';
import { formLabelClasses } from '@mui/material/FormLabel';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
import SovosToolbarGroup from '../sovos-toolbar-group';
import SovosSelect from '../sovos-select';
const StyledSelect = styled(SovosSelect)(_ref => {
  let {
    theme: {
      palette,
      spacing
    }
  } = _ref;
  return {
    ["&.".concat(textFieldClasses.root)]: {
      alignItems: 'center',
      display: 'inline-flex',
      height: '100%',
      padding: 0,
      '&:hover, &:focus': {
        background: palette.action.hover
      }
    },
    ["& .".concat(inputBaseClasses.root)]: {
      height: '100%'
    },
    ["& .".concat(selectClasses.select)]: {
      // we can't override the padding on the input element because of MUI selector specificity,
      // so force the padding to position the text correctly
      padding: '0 !important',
      paddingInlineEnd: "".concat(spacing(4.5), " !important"),
      paddingInlineStart: "".concat(spacing(2), " !important")
    },
    ["& .".concat(selectClasses.icon)]: {
      width: spacing(3),
      marginInlineEnd: spacing(0.5)
    },
    ["& > .".concat(formLabelClasses.root)]: {
      visibility: 'hidden'
    },
    ["label + .".concat(inputBaseClasses.root)]: {
      marginBlockStart: 0
    }
  };
});

/**
 * `SovosToolbarDropdown` (opens a dropdown menu). **Note**: must be a
 * child of `SovosToolbarActions` component
 *
 * **Note**: must be a child of `SovosToolbar`
 */
const SovosToolbarDropdown = _ref2 => {
  let {
    className,
    // eslint-disable-next-line react/prop-types
    color,
    // ignore the color prop
    'data-testid': dataTestId,
    label,
    sx,
    value = '',
    ...props
  } = _ref2;
  return /*#__PURE__*/React.createElement(SovosToolbarGroup, {
    className: clsx('sovosToolbarDropdown', className),
    "data-testid": dataTestId,
    sx: sx
  }, /*#__PURE__*/React.createElement(StyledSelect, _extends({
    "aria-label": label,
    className: "sovosToolbarDropdown__select",
    disableUnderline: true,
    value: value,
    variant: "standard"
  }, props)));
};
SovosToolbarDropdown.propTypes = {
  /**
   * The content of the toolbar dropdown. A collection of `SovosMenuItem`
   */
  children: node.isRequired,
  /**
   * Extend the class name applied to the root element
   */
  className: string,
  /**
   * @ignore
   */
  'data-testid': string,
  /**
   * Text label for `aria-label` attribute
   */
  label: string,
  /**
   * The system prop that allows defining system overrides as well as
   * additional CSS styles.
   */
  sx: oneOfType([arrayOf(oneOfType([func, object, bool])), func, object]),
  /**
   * Value of the input
   */
  value: any
};
export default SovosToolbarDropdown;